import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useShortIdContext } from '@air/provider-short-id';

import { CameraDetailsSection } from '~/components/AssetModalV2/InfoPanel/Advanced/CameraDetailsSection';
import { useCollapsibleSectionsContext } from '~/components/AssetModalV2/InfoPanel/CollapsibleSectionsContextProvider';
import { CollapsibleSection } from '~/components/AssetModalV2/InfoPanel/components/CollapsibleSection';
import { centralizedClipIdSelector } from '~/store/centralizedClip/selectors';
import { usePublicClipMetadata } from '~/swr-hooks/clips/usePublicClipMetadata';

export const PublicAdvancedCollapsibleSection = memo(() => {
  const { expandedSections, toggleSection } = useCollapsibleSectionsContext();
  const isExpanded = expandedSections.advanced;
  const onOpenChange = useCallback(() => {
    toggleSection('advanced');
  }, [toggleSection]);

  const clipId = useSelector(centralizedClipIdSelector);
  const { shortId } = useShortIdContext();
  const { data: clipMetadata } = usePublicClipMetadata({ clipId, shortId });

  if (!clipMetadata || clipMetadata?.data.length === 0) {
    return null;
  }

  return (
    <CollapsibleSection
      title="Advanced"
      isExpanded={isExpanded}
      onOpenChange={onOpenChange}
      data-testid="ADVANCED_SECTION"
    >
      <CameraDetailsSection clipMetadata={clipMetadata.data} />
    </CollapsibleSection>
  );
});

PublicAdvancedCollapsibleSection.displayName = 'PublicAdvancedCollapsibleSection';
